import { ACCOUNT_PERMISSION_CODES } from './chucNangs/accountChucNangs'
import { DIA_CHI_NHAN_HANG_PERMISSION_CODES } from './chucNangs/diaChiNhanHangChucNangs'
import { THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES } from './chucNangs/thongTinXuatHoaDonChucNangs'
import { PHIEU_NHAP_KHO_PERMISSION_CODES } from './chucNangs/phieuNhapKhoChucNangs'
import { PHIEU_XUAT_KHO_PERMISSION_CODES } from './chucNangs/phieuXuatKhoChucNangs'
import { DAT_HANG_PERMISSION_CODES } from './chucNangs/datHangChucNangs'
import { HOA_DON_PERMISSION_CODES } from './chucNangs/hoaDonChucNangs'
import { DAT_HANG_NCC_PERMISSION_CODES } from './chucNangs/datHangNccChucNangs'
import { PHIEU_NHAN_HANG_PERMISSION_CODES } from './chucNangs/phieuNhanHangChucNangs'
import { TRA_HANG_PERMISSION_CODES } from './chucNangs/traHangChucNangs'
import { YEU_CAU_SUA_CHUA_PERMISSION_CODES } from './chucNangs/yeuCauSuaChuaChucNangs'
import { KIEM_KE_PERMISSION_CODES } from './chucNangs/kiemKeChucNangs'
import { AUDIT_PERMISSION_CODES } from './chucNangs/auditChucNangs'
import { DASHBOARD_PERMISSION_CODES } from './chucNangs/dashboardChucNangs'
import { NHOM_HANG_PERMISSION_CODES } from './chucNangs/nhomHangChucNangs'
import { BANG_GIA_PERMISSION_CODES } from './chucNangs/bangGiaChucNangs'
import { NHA_CUNG_CAP_PERMISSION_CODES } from './chucNangs/nhaCungCapChucNangs'
import { NHOM_KHACH_HANG_PERMISSION_CODES } from './chucNangs/nhomKhachHangChucNangs'
import { KHACH_HANG_PERMISSION_CODES } from './chucNangs/khachHangChucNangs'
import { PRODUCT_PERMISSION_CODES } from './chucNangs/productChucNangs'
import { SETTINGS_PERMISSION_CODES } from './chucNangs/settingsChucNangs'
import { DANH_MUC_THU_KHAC_PERMISSION_CODES } from './chucNangs/danhMucThuKhacChucNangs'
import { DON_VI_TINH_PERMISSION_CODES } from './chucNangs/donViTinhChucNangs'
import { THUONG_HIEU_PERMISSION_CODES } from './chucNangs/thuongHieuChucNangs'
import { PHAN_LOAI_SAN_PHAM_PERMISSION_CODES } from './chucNangs/phanLoaiSanPhamChucNangs'
import { THONG_TIN_VAT_HANG_HOA_PERMISSION_CODES } from './chucNangs/thongTinVatHangHoaChucNangs'
import { THUOC_TINH_PERMISSION_CODES } from './chucNangs/thuocTinhChucNangs'
import { VI_TRI_PERMISSION_CODES } from './chucNangs/viTriChucNangs'
import { DIA_CHI_LAY_HANG_PERMISSION_CODES } from './chucNangs/diaChiLayHangChucNangs'
import { USER_PERMISSION_CODES } from './chucNangs/userChucNangs'
import { BAO_CAO_PERMISSION_CODES } from './chucNangs/baoCaoChucNangs'
import { CONG_NO_PERMISSION_CODES } from './chucNangs/congNoChucNangs'
import { CHUYEN_HANG_PERMISSION_CODES } from './chucNangs/chuyenHangChucNangs'
import { SO_QUY_PERMISSION_CODES } from './chucNangs/soQuyChucNangs'
import { MAU_IN_PERMISSION_CODES } from './chucNangs/mauInChucNangs'
import { YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES } from './chucNangs/yeuCauXuatHoaDonChucNangs'
import { VAN_HANH_PERMISSION_CODES } from './chucNangs/vanHanhChucNangs'
import { BAN_ONLINE_PERMISSION_CODES } from './chucNangs/banOnlineChucNangs'
import { TAG_NHAN_VIEN_PERMISSION_CODES } from './chucNangs/tagNhanVienChucNangs'
import { CHAT_PERMISSION_CODES } from './chucNangs/chatChucNangs'

export const ALL_CHUCNANG_PERMISSION_CODES = {
  ...USER_PERMISSION_CODES,
  ...PRODUCT_PERMISSION_CODES,
  ...NHA_CUNG_CAP_PERMISSION_CODES,
  ...BANG_GIA_PERMISSION_CODES,
  ...NHOM_KHACH_HANG_PERMISSION_CODES,
  ...KHACH_HANG_PERMISSION_CODES,
  ...NHOM_HANG_PERMISSION_CODES,
  ...DASHBOARD_PERMISSION_CODES,
  ...DIA_CHI_NHAN_HANG_PERMISSION_CODES,
  ...THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES,
  ...PHIEU_NHAP_KHO_PERMISSION_CODES,
  ...PHIEU_XUAT_KHO_PERMISSION_CODES,
  ...DAT_HANG_PERMISSION_CODES,
  ...HOA_DON_PERMISSION_CODES,
  ...DAT_HANG_NCC_PERMISSION_CODES,
  ...PHIEU_NHAN_HANG_PERMISSION_CODES,
  ...TRA_HANG_PERMISSION_CODES,
  ...YEU_CAU_SUA_CHUA_PERMISSION_CODES,
  ...KIEM_KE_PERMISSION_CODES,
  ...DANH_MUC_THU_KHAC_PERMISSION_CODES,
  ...DON_VI_TINH_PERMISSION_CODES,
  ...THUONG_HIEU_PERMISSION_CODES,
  ...PHAN_LOAI_SAN_PHAM_PERMISSION_CODES,
  ...THONG_TIN_VAT_HANG_HOA_PERMISSION_CODES,
  ...THUOC_TINH_PERMISSION_CODES,
  ...VI_TRI_PERMISSION_CODES,
  ...DIA_CHI_LAY_HANG_PERMISSION_CODES,
  ...AUDIT_PERMISSION_CODES,
  ...ACCOUNT_PERMISSION_CODES,
  ...SETTINGS_PERMISSION_CODES,
  ...BAO_CAO_PERMISSION_CODES,
  ...CONG_NO_PERMISSION_CODES,
  ...CHUYEN_HANG_PERMISSION_CODES,
  ...SO_QUY_PERMISSION_CODES,
  ...MAU_IN_PERMISSION_CODES,
  ...YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES,
  ...VAN_HANH_PERMISSION_CODES,
  ...BAN_ONLINE_PERMISSION_CODES,
  ...TAG_NHAN_VIEN_PERMISSION_CODES,
  ...CHAT_PERMISSION_CODES,
} as const

export const CHUC_NANG_FILTERS = {} as const
